<template>
    <section class="menu-section-area">
        
        <div class="mean-bar">
            <div class="navoverlay"></div>
            <Slide right >
                <ul class="navbar-nav text-capitalize ml-auto">
                    <li class="nav-item dropdown-box" v-for="(data, index) of menuData" :key="index">
                        <router-link 
                            class="nav-link js-scroll-trigger" 
                            :to="`/${data.slug}`" 
                        >
                            {{ data.name }}
                        </router-link>
                    </li>   
                    <li class="nav-item dropdown-box">
                        <a 
                            class="nav-link js-scroll-trigger" 
                            href="//rest.thrubits.com" 
                            target="_blank"
                            >
                            Thrubits Restaurants
                        </a>
                    </li>                         
                </ul>
            </Slide>     
            <nav class="mean-nav">
                <router-link to="/">
                    <img class="mobile-logo" src="/img/logo.png" alt="Logo">
                </router-link>                   
            </nav>
        </div>
        
        <!-- Top Menu -->
        <div class="top-nav">
            <div class="container">
                <div class="row">
                    <div class="col-sm-8">
                        <ul class="left-top-menu">
                            <!-- <li><a href="contact.html"><i class="far fa-comment"></i>Live Chat</a></li> -->
                            <li v-if="$store.state.site.siteEmail"><a :href="`mailto:${$store.state.site.siteEmail}`"><i class="fas fa-envelope"></i>{{ $store.state.site.siteEmail }}</a></li>
                            <li v-if="$store.state.site.sitePhone"><a :href="`tel:${$store.state.site.sitePhone}`"><i class="fas fa-phone-alt"></i>{{ $store.state.site.sitePhone }}</a></li>
                        </ul>
                    </div>
                    <div class="col-sm-4">
                        <ul class="right-top-menu text-right">
                            <li v-if="getAuthUserName">
                                <router-link to="/dashboard">Welcome {{ getAuthUserName }}!</router-link>
                            </li>
                            <fragment v-else>
                                <li><router-link to="/account/login">Login</router-link></li>
                                <li><router-link to="/account/registration">Registration</router-link></li>
                            </fragment>
                            <li>
                                <router-link to="/contact-us">Help</router-link>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
        <!-- Top Menu -->

        <!-- Navigation -->
        <nav class="navbar navbar-expand-lg fixed-top d-none d-sm-none d-md-block d-lg-block d-xl-block" id="mainNav">
            <div class="container">
                <router-link class="navbar-brand" to="/">
                    <img src="../../public/img/logo.png" :alt="$store.state.site.siteTitle" class="img-fluid">
                </router-link>
                <button class="navbar-toggler navbar-toggler-right" type="button" data-toggle="collapse" data-target="#navbarResponsive" aria-expanded="false" aria-label="Toggle navigation">
                    <i class="fas fa-bars"></i>
                </button>
                <div class="collapse navbar-collapse" id="navbarResponsive">
                    <ul class="navbar-nav text-capitalize ml-auto">
                        <li class="nav-item dropdown-box" v-for="(data, index) of menuData" :key="index">
                            <router-link 
                                class="nav-link js-scroll-trigger" 
                                :to="`/${data.slug}`" 
                            >
                                {{ data.name }}
                            </router-link>
                        </li>   
                        <li class="nav-item dropdown-box">
                            <a 
                                class="nav-link js-scroll-trigger" 
                                href="//rest.thrubits.com" 
                                target="_blank"
                                >
                                Thrubits Restaurants
                            </a>
                        </li>                     
                    </ul>
                </div>
            </div>
        </nav>
        <!-- Navigation -->
    </section>
</template>

<script>
import { Slide } from 'vue-burger-menu' 
// import $ from "jquery";

export default {
    components: {
        Slide // Register your component
    },
    data(){
        return {
            currentRoute: this.$route.meta.slug,
            menuData: [
                {name: 'Home', slug: ''},
                {name: 'About Us', slug: 'about-us'},
                {name: 'Services', slug: 'services'},
                {name: 'Pricing', slug: 'pricing'},
                {name: 'QR Code', slug: 'qr-code'},
                {name: 'Contact Us', slug: 'contact-us'}
            ]
        }
    },
    methods: {
        navbarCollapse(){
            if (window.pageYOffset > 100) {
                document.querySelector("#mainNav").classList.add("navbar-shrink");
            } else {
                document.querySelector("#mainNav").classList.remove("navbar-shrink");
            }
        }
    },
    computed: {
        getAuthUserName(){
            return this.$store.state.auth.name
        }
    },
    created: function(){        
        window.addEventListener('scroll', this.navbarCollapse);        
        // Collapse the navbar when page is scrolled
       // $(window).scroll(navbarCollapse);
    //    var scripts = [
    //         "/js/jquery-3.6.0.min.js",
    //         "/js/jquery.meanmenu.min.js"
    //     ];
    //     scripts.forEach(script => {
    //         let tag = document.createElement("script");
    //         tag.setAttribute("src", script);
    //         document.head.appendChild(tag);
    //     });
    //     $('nav.mobile_menu').meanmenu({
    //         meanScreenWidth: '991'
    //     });
    //     $('nav.mean-nav li > a:first-child').on('click', function () {
    //         $('a.meanmenu-reveal').click();
    //     });
       
        
    },
    watch: {
        "$route"(){
            this.currentRoute = this.$route.meta.slug
            document.querySelector('.bm-cross-button').click()
        }
    }
}

</script>

<style scoped>
#mainNav.navbar-shrink .navbar-nav .nav-item .nav-link.router-link-active.router-link-exact-active{color: #321d9a!important;}
.bm-burger-button {
    position: fixed;
    width: 36px;
    height: 30px;
    left: 36px;
    cursor: pointer;
}

.cross-style {
    position: absolute;
    top: 12px;
    right: 2px;
    cursor: pointer;
}
.bm-cross {
    background: #bdc3c7;
}
.bm-cross-button {
    height: 24px;
    width: 24px;
}
.bm-menu {
    height: 100%; /* 100% Full-height */
    width: 0; /* 0 width - change this with JavaScript */
    position: fixed; /* Stay in place */
    z-index: 1000; /* Stay on top */
    top: 0;
    left: 0;
    overflow-x: hidden; /* Disable horizontal scroll */
    padding-top: 60px; /* Place content 60px from the top */
    transition: 0.5s; /*0.5 second transition effect to slide in the sidenav*/
}

.bm-overlay {
    background: rgba(0, 0, 0, 0.3);
}
.bm-item-list {
    color: #b8b7ad;
    margin-left: 10%;
    font-size: 20px;
}
.bm-item-list > * {
    display: flex;
    text-decoration: none;
    padding: 0.7em;
}
.bm-item-list > * > span {
    margin-left: 10px;
    font-weight: 700;
    color: white;
}
.navbar-nav .nav-link{color:#fff;}
</style>